import { sha256 } from "js-sha256";
import { constant } from "../config/constant";
import moment from "moment";
import {
  getSessionId,
  getUserType,
  getDeviceType,
  getMarkets,
  getUserId,
  getLocationName,
} from "../DAPI/src/component/check-in/select-passengers/flightStatusHelper";
import { store } from "../store";

const dataLayer = window?.dataLayer || [];

const getDeviceName = () => {
const state = store?.getState();
const deviceName = state?.dapiReducer?.deviceSlice?.name;
return deviceName;
}

const getTripType = () => {
const state = store?.getState();
const tripType = state?.dapiReducer?.checkin?.tripType;
return tripType;
}

export const hashToUpperCase = (data) => {
  if (data) return sha256(data)?.toUpperCase();
  else return "";
};

export const basicInfo = (page) => {
  let basicData = {
    language: window.location.pathname.split("/")[1].split("-")[0],
    market: window.location.pathname.split("/")[1].split("-")[1],
    page_type: page,
  };
  window?.dataLayer?.push(basicData);
};


export const loginstatus = () =>{
 let Loginstatus = {
        login_status:
          localStorage?.getItem("isROPLoggedIn") === "true"
            ? "Logged IN"
            : "Guest",
        userId: sessionStorage.getItem("memberId")
          ? sessionStorage.getItem("memberId")
          : "NA",
        siteLanguage: window.location.pathname.split("/")[1].split("-")[0],
        siteCountry: window.location.pathname.split("/")[1].split("-")[1],
        platform: deviceType,
        market: window.location.pathname.split("/")[1],
 }
   window?.dataLayer?.push(Loginstatus);
}



export const pageInfo = (page) => {
  const pageData = {
    primaryCategory: page?.primaryCategory,
    pageId: page?.pageId,
    pageName: page?.pageName,
    event: constant.osciDataLayer.pageEvent,
    market: page?.market,
    timestamp: new Date().toString(),
  };
  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.pageEvent
  );

  if (lastEventIndex !== -1) {
    // Update only the necessary fields
    dataLayer[lastEventIndex] = { ...dataLayer?.[lastEventIndex], ...pageData };
  } else {
    // If no "page_view" exists, push a new one
    dataLayer?.push(pageData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const bookFlightInfo = (data) => {
  const bookFlightData = {
    from: data?.from?.airportCode,
    to: data?.to?.airportCode,
    fromDate: data?.depart,
    toDate: data?.return,
    type: data?.type,
    class: data?.class,
    pax: data?.passengers,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.bookflightEvent,
    eventName:constant.osciDataLayer.bookflight_eventName,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    type_id :data?.type_id,
    tsession_id: data?.tsession_id || "NA",
    search_ond: data?.search_ond,
    market_language:data?.market_language,
    promocode: data?.promocode || "NA",
    timestamp: new Date().toString(),
    device_name: getDeviceName(),
    user_id: getUserId(),
  };
  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.bookflightEvent
  );

  // if (lastEventIndex !== -1) {
  //   dataLayer[lastEventIndex] = {
  //     ...dataLayer[lastEventIndex],
  //     ...bookFlightData,
  //   };
  // } else {
    dataLayer?.push(bookFlightData);
  // }

  window.dataLayer = dataLayer; // Update the data layer
};
export const nonaccilllary = (data) => {
  
  const toggleCategoryview = {
    event_Category:data?.eventCategory,
    primary_category: data?.primaryCategory,
    event_action: data?.eventLabel,
    event: constant?.osciDataLayer?.viewAnicileryEvent,
    eventName:constant?.osciDataLayer?.viewAnicileryEvent,
    pnr_record_locator: data?.pnr_record_locator || "NA",
    flightId: data?.flightId || "NA",
    fromDate: data?.from_date || "NA",
    toDate: data?.to_date || "NA",
    travel_class: data.travelClass || "NA",
    event_label: "NA",
    rop_member_status: "NA",
    pageId: data?.pageId,
    pageName: data?.pageName,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  
  }
    dataLayer.push(toggleCategoryview);
    
    window.dataLayer = dataLayer; // Update the data layer
  };
  
  
  export const selectnonaccilllary = (data) => {
  
  const selecttoggleCategoryview = {
    event_category:data?.eventCategory,
    primary_category: data?.primaryCategory,
    event_label: data?.eventLabel,
    button_text: data?.buttonText,
    event_action: data?.eventAction,
    event: constant?.osciDataLayer?.selectAnicileryEvent,
    eventName:constant?.osciDataLayer?.selectAnicileryEvent,
    pageId: data?.pageId,
    pageName: data?.pageName,
    rop_member_status: "NA",
    flightId: data?.flightId || "NA",
    pnr_record_locator: data?.pnr_record_locator || "NA",
    fromDate: data?.from_date || "NA",
    toDate: data?.to_date || "NA",
    travel_class: data.travelClass || "NA",
    origin: data?.origin || "NA",
    destination: data?.destination || "NA",
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  
  }
    dataLayer.push(selecttoggleCategoryview);
    
    window.dataLayer = dataLayer; // Update the data layer
  }

export const bookFlightMultiCityInfo = (data) => {
  const bookFlightData = {
    multiCityData: data?.multiCityData,
    type: data?.type,
    class: data?.class,
    count: data?.count,
    pax: data?.pax,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.bookFlightMultiCityEvent,
    eventName:constant.osciDataLayer.bookFlightMultiCityEvent,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform: data?.platform,
    Market: data?.market,
    type_id: data?.type_id,
    tsession_id: data?.tsession_id || "NA",
    search_ond: data?.search_ond,
    market_language:data?.market_language,
    timestamp: new Date().toString(),
    promocode: data?.promocode || "NA",
    device_name: getDeviceName(),
    user_id: getUserId(),
  };
  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.bookFlightMultiCityEvent
  );

  // if (lastEventIndex !== -1) {
  //   dataLayer[lastEventIndex] = {
  //     ...dataLayer[lastEventIndex],
  //     ...bookFlightData,
  //   };
  // } else {
    dataLayer?.push(bookFlightData);
  // }

  window.dataLayer = dataLayer; // Update the data layer
};

export const manageBookingInfo = (data) => {
  const manageBookingData = {
    ticketNumber: data?.ticketNumber,
    //lastName: hashToUpperCase(data?.lastName), // to be removed as per suggestion from KJugg
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.manageBookEvent,
    eventName:constant.osciDataLayer.manageBookEvent,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    timestamp: new Date().toString(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.manageBookEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...manageBookingData,
    };
  } else {
    dataLayer?.push(manageBookingData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const checkinInfo = (data) => {
  const checkinData = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    timestamp: new Date().toString(),
    login_status:data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type :data?.platform,
    market_language:data?.market,
    event:constant.osciDataLayer.checkInEvent,
    user_type:data?.userType,
    pnr_record_locator:data?.ticketNumber,
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName(),
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.checkInEvent
  );

  dataLayer?.push(checkinData);

  window.dataLayer = dataLayer; // Update the data layer
};

export const flightStatusInfo = (data) => {
  const flightStatusData = {
    from: data?.from?.airportCode ?? "",
    to: data?.to?.airportCode ?? "",
    flightNumber: data?.flightNumber ?? "",
    type: data?.type,
    date: moment(data?.date)?.format("YYYY-MM-DD"),
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.flightStatusEvent,
    eventName: constant?.osciDataLayer?.flightStatusEvent_eventName,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    timestamp: new Date().toString(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.flightStatusEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...flightStatusData,
    };
  } else {
    dataLayer?.push(flightStatusData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const ropEnrolInfo = (data) => {
  const ropEnrolData = {
    gender: data?.gender,
    country: data?.country,
    pageId: data?.pageId,
    pageName: data?.pageName,
    rop_news_subscription: data?.newsCheck !== "N",
    rop_partners_news_subscription: data?.thirdPartyCheck !== "N",
    event: "ropEnrol",
    eventName: constant?.osciDataLayer?.ropenroll_eventName,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    timestamp: new Date().toString(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "ropEnrol"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...ropEnrolData,
    };
  } else {
    dataLayer.push(ropEnrolData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const ropEnrolSuccessInfo = (data) => {
  const ropEnrolSuccessData = {
    memberId: hashToUpperCase(data?.memberID),
    event: "ropEnrolSuccess",
    eventName: constant?.osciDataLayer?.ropenrollsuccess_eventName,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "ropEnrolSuccess"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...ropEnrolSuccessData,
    };
  } else {
    dataLayer.push(ropEnrolSuccessData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const newsletterSubscribeInfo = (data) => {
  const newsletterSubscribeData = {
    preferredLocation: data?.preferenceLocation,
    event: "newsletterSubscribe",
    eventName: constant?.osciDataLayer?.page_newsletterSubscribe_event_name,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "newsletterSubscribe"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...newsletterSubscribeData,
    };
  } else {
    dataLayer.push(newsletterSubscribeData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const newsletterUnsubscribeInfo = (data) => {
  const newsletterUnsubscribeData = {
    event: "newsletterUnsubscribe",
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    eventName: constant?.osciDataLayer?.page_newsletterSubscribe_event_name,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "newsletterUnsubscribe"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...newsletterUnsubscribeData,
    };
  } else {
    dataLayer.push(newsletterUnsubscribeData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const giftMilesInfo = (data) => {
  const giftMilesData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.giftingMiles,
    currency: data?.currency,
    totalAmount: data?.totalAmount,
    recipient: hashToUpperCase(data?.receipientROPId),
    event: "giftMiles",
    eventName: constant?.osciDataLayer?.page_giftMiles_event_name,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "giftMiles"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...giftMilesData,
    };
  } else {
    dataLayer.push(giftMilesData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const giftMilesSuccessInfo = (data) => {
  const giftMilesSuccessData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.miles?.mileage,
    currency: data?.currency,
    totalAmount: data?.totalAmount,
    recipient: hashToUpperCase(data?.recepientRopMemberId),
    transactionId: hashToUpperCase(data?.tid),
    event: "giftMilesSuccess",
    eventName: constant?.osciDataLayer?.page_giftMilesSuccess_event_name,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
     login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "giftMilesSuccess"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...giftMilesSuccessData,
    };
  } else {
    dataLayer.push(giftMilesSuccessData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const giftMilesErrorInfo = (data) => {
  const giftMilesErrorData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.miles?.mileage,
    currency: data?.currency,
    totalAmount: data?.totalAmount,
    recipient: hashToUpperCase(data?.recepientRopMemberId),
    event: "giftMilesError",
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    eventName: constant?.osciDataLayer?.page_giftMilesError_event_name,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "giftMilesError"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...giftMilesErrorData,
    };
  } else {
    dataLayer.push(giftMilesErrorData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const mileagePurchaseInfo = (data) => {
  const mileagePurchaseData = {
    memberId: hashToUpperCase(data?.memberId),
    miles: data?.milesPurchased,
    currency: data?.currency,
    totalAmount: data?.totalAmount,
    event: constant?.osciDataLayer?.purchaseMilesEvent,
    eventName: constant?.osciDataLayer?.page_purchaseMiles_event_name,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.osciDataLayer?.purchaseMilesEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...mileagePurchaseData,
    };
  } else {
    dataLayer.push(mileagePurchaseData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const mileagePurchaseSuccessInfo = (data) => {
  const mileagePurchaseSuccessData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.purchaseMiles?.mileage,
    currency: data?.currency,
    totalAmount: data?.totalAmount,
    transactionId: data?.tid,
    event: constant?.osciDataLayer?.purchaseMilesSuccessEvent,
    eventName: constant?.osciDataLayer?.page_purchaseMilesSuccess_event_name,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.osciDataLayer?.purchaseMilesSuccessEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...mileagePurchaseSuccessData,
    };
  } else {
    dataLayer.push(mileagePurchaseSuccessData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const mileagePurchaseErrorInfo = (data) => {
  const mileagePurchaseErrorData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.purchaseMiles?.mileage,
    currency: data?.currency,
    totalAmount: data?.totalAmount,
    event: constant?.osciDataLayer?.purchaseMilesErrorEvent,
    eventName: constant?.osciDataLayer?.page_purchaseMilesError_event_name,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.osciDataLayer?.purchaseMilesErrorEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...mileagePurchaseErrorData,
    };
  } else {
    dataLayer.push(mileagePurchaseErrorData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const transferMilesInfo = (data) => {
  const transferMilesData = {
    memberId: hashToUpperCase(data?.memberId),
    miles: data?.transferMiles,
    currency: data?.currencyCode,
    totalAmount: data?.amount,
    recipient: hashToUpperCase(data?.receipientROPId),
    event: "transferMiles",
    eventName: constant?.osciDataLayer?.page_transferMiles_event_name,
    timestamp: new Date().toString(),
    pageId: data?.pageId,
    pageName: data?.pageName,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "transferMiles"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...transferMilesData,
    };
  } else {
    dataLayer.push(transferMilesData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const transferMilesSuccessInfo = (data) => {
  const transferMilesSuccessData = {
    memberId: hashToUpperCase(data?.memberId),
    transactionId: hashToUpperCase(data?.tid),
    miles: data?.transferMiles,
    totalAmount: data?.amount,
    currency: data?.currencyCode,
    recipient: hashToUpperCase(data?.receipientROPId),
    event: "transferMilesSuccess",
    eventName: constant?.osciDataLayer?.page_transferMilesSuccess_event_name,
    timestamp: new Date().toString(),
    pageId: data?.pageId,
    pageName: data?.pageName,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "transferMilesSuccess"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...transferMilesSuccessData,
    };
  } else {
    dataLayer.push(transferMilesSuccessData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const transferMilesErrorInfo = (data) => {
  const transferMilesErrorData = {
    memberId: hashToUpperCase(data?.memberId),
    miles: data?.transferMiles,
    totalAmount: data?.amount,
    currency: data?.currencyCode,
    recipient: hashToUpperCase(data?.receipientROPId),
    event: "transferMilesError",
    eventName: constant?.osciDataLayer?.page_transferMilesError_event_name,
    timestamp: new Date().toString(),
    pageId: data?.pageId,
    pageName: data?.pageName,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "transferMilesError"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...transferMilesErrorData,
    };
  } else {
    dataLayer.push(transferMilesErrorData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const extendExpiryMilesInfo = (data) => {
  const extendExpiryMilesData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.extendingMiles,
    currency: data?.currency,
    totalAmount: data?.amountToBePaid,
    event: "extendExpiryMiles",
    timestamp: new Date().toString(),
    pageId: data?.pageId,
    pageName: data?.pageName,
    eventName: constant?.osciDataLayer?.page_extendExpiryMiles_event_name,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "extendExpiryMiles"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...extendExpiryMilesData,
    };
  } else {
    dataLayer.push(extendExpiryMilesData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const extendExpiryMilesSuccessInfo = (data) => {
  const extendExpiryMilesSuccessData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.extendingMiles,
    currency: data?.currency,
    transactionId: data?.tid,
    event: "extendExpiryMilesSuccess",
    timestamp: new Date().toString(),
    pageId: data?.pageId,
    pageName: data?.pageName,
    eventName: constant?.osciDataLayer?.page_extendExpiryMilesSuccess_event_name,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "extendExpiryMilesSuccess"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...extendExpiryMilesSuccessData,
    };
  } else {
    dataLayer.push(extendExpiryMilesSuccessData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const extendExpiryMilesErrorInfo = (data) => {
  const extendExpiryMilesErrorData = {
    memberId: hashToUpperCase(data?.memberid),
    miles: data?.extendingMiles,
    currency: data?.currency,
    totalAmount: data?.amountToBePaid,
    event: "extendExpiryMilesError",
    eventName: constant?.osciDataLayer?.page_extendExpiryMilesError_event_name,
    timestamp: new Date().toString(),
    pageId: data?.pageId,
    pageName: data?.pageName,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "extendExpiryMilesError"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...extendExpiryMilesErrorData,
    };
  } else {
    dataLayer.push(extendExpiryMilesErrorData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const crmSignUpInfo = (data) => {
  const crmSignUpData = {
    country: data?.country,
    newsletter_subscription: data?.newsletter_subscription,
    newsletter_preference: data?.newsLetterPreference,
    event: "mythaiEnrol",
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    eventName: constant?.osciDataLayer?.page_mythaiEnrol_event_name,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "mythaiEnrol"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...crmSignUpData,
    };
  } else {
    dataLayer.push(crmSignUpData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const crmSignUpSuccessInfo = (data) => {
  const crmSignUpSuccessData = {
    event: "mythaiEnrolSuccess",
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    eventName: constant?.osciDataLayer?.page_mythaiEnrolSuccess_event_name,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "mythaiEnrolSuccess"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...crmSignUpSuccessData,
    };
  } else {
    dataLayer.push(crmSignUpSuccessData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const ropSignInInfo = (data) => {
  const ropSignInData = {
    memberId: hashToUpperCase(data?.memberId),
    event: "ropSignIn",
    title: data?.title,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    eventName: constant?.osciDataLayer?.page_mythairopropsignin_event_name,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "ropSignIn"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...ropSignInData,
    };
  } else {
    dataLayer.push(ropSignInData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const crmSignInInfo = (data) => {
  const crmSignInData = {
    memberId: hashToUpperCase(data?.memberId),
    event: "mythaiSignIn",
    eventName: constant?.osciDataLayer?.page_mythaicrmsignin_event_name,
    title: hashToUpperCase(data?.title),
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === "mythaiSignIn"
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...crmSignInData,
    };
  } else {
    dataLayer.push(crmSignInData);
  }

  window.dataLayer = dataLayer; // Update the data layer
};

export const redemptionSearchInfo = (data) => {
  const searchInfoData = {
    from: data?.from?.airportCode,
    to: data?.to?.airportCode,
    fromDate: moment(data?.startDate).format("YYYY-MM-DD"),
    toDate: moment(data?.endDate).format("YYYY-MM-DD"),
    type: data?.journeyType,
    pax: data?.pax,
    redemptionType: data?.isStarAlliance ? "Star Alliance" : "Thai Airways",
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.redemptionFlightEvent,
    eventName: constant?.osciDataLayer?.page_redemptionFlightEvent_event_name,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName(),
    user_id: getUserId(),
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.redemptionFlightEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...searchInfoData,
    };
  } else {
    dataLayer?.push(searchInfoData);
  }

  window.dataLayer = dataLayer;
};

export const redemptionSearchMultiCityInfo = (data) => {
  const searchInfoData = {
    multicityData: data?.multiCityData,
    redemptionType: data?.redemptionType,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.redemptionBookFlightMultiCityEvent,
    eventName: constant?.osciDataLayer?.page_redemptionBookFlightMultiCityEvent_event_name,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName(),
    user_id: getUserId(),
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event === constant.osciDataLayer.redemptionBookFlightMultiCityEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...searchInfoData,
    };
  } else {
    dataLayer?.push(searchInfoData);
  }

  window.dataLayer = dataLayer;
};

export const redemptionFlightSelectionInfo = (data) => {
  const flightSelectionInfoData = {
    flightSelectionData: data?.selectedFlight,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.redemptionFlightSelectionEvent,
    eventName: constant?.osciDataLayer?.page_redemptionFlightSelection_event_name,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event === constant.osciDataLayer.redemptionFlightSelectionEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...flightSelectionInfoData,
    };
  } else {
    dataLayer?.push(flightSelectionInfoData);
  }

  window.dataLayer = dataLayer;
};

export const redemptionPassengerSelectionInfo = (data) => {
  const passengerInfoData = {
    passengerSelectionData: data?.selectedPassengers,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.redemptionPassengerSelectionEvent,
    eventName: constant?.osciDataLayer?.page_redemptionPassengerSelection_event_name,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event === constant.osciDataLayer.redemptionPassengerSelectionEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...passengerInfoData,
    };
  } else {
    dataLayer?.push(passengerInfoData);
  }

  window.dataLayer = dataLayer;
};

export const redemptionReviewinformation = (data) => {
  const reviewInfoData = {
    flightData: data?.flightData,
    pnr: data?.pnr,
    totalFare: data?.totalFare,
    totalMiles: data?.totalMiles,
    currency: data?.currency,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant.osciDataLayer.redemptionReviewInformationEvent,
    eventName: constant?.osciDataLayer?.page_redemptionReviewInformation_event_name,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event === constant.osciDataLayer.redemptionReviewInformationEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...reviewInfoData,
    };
  } else {
    dataLayer?.push(reviewInfoData);
  }

  window.dataLayer = dataLayer;
};

export const redemptionConfirmationSummary = (data) => {
  const reviewConfirmationData = {
    flightData: data?.flightData,
    pnr: data?.pnr, 
    totalFare: data?.totalFare,
    totalMiles: data?.totalMiles,
    currency: data?.currency,
    event: constant.osciDataLayer.redemptionConfirmationEvent,
    bookingStatus: data?.bookingStatus,
    paymentStatus: data?.paymentStatus,
    success: data?.success,
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    eventName: constant?.osciDataLayer?.page_redemptionConfirmation_event_name,
     login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant.osciDataLayer.redemptionConfirmationEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...reviewConfirmationData,
    };
  } else {
    dataLayer?.push(reviewConfirmationData);
  }

  window.dataLayer = dataLayer;
};

export const redemptionError = (data) => {
  const reviewRedemptionData = {
    error: data?.error || "",
    success: data?.success || "",
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    event: constant?.osciDataLayer?.redemptionErrorEvent,
    eventName: constant?.osciDataLayer?.page_redemptionError_event_name,
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.osciDataLayer?.redemptionErrorEvent
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...reviewRedemptionData,
    };
  } else {
    dataLayer?.push(reviewRedemptionData);
  }

  window.dataLayer = dataLayer;
};

export const popularFare = (data) => {
  const popularFareData = {
    popularFareRoute: `${data?.popularFareRouteDepart} - ${data?.popularFareRouteArrival}`,
    popularFarePrice: data?.popularFarePrice,
    event: constant?.osciDataLayer?.popularFaresBookNow,
    eventName: constant?.osciDataLayer?.page_popularFaresBookNow_event_name,
    pageId: data?.pageId,
    pageName: data?.pageName,
    timestamp: new Date().toString(),
    login_status:getUserType("status"),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    Platform :data?.platform,
    Market:data?.market,
    market_language: getMarkets("market"),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item?.event === constant?.osciDataLayer?.popularFaresBookNow
  );

  if (lastEventIndex !== -1) {
    dataLayer[lastEventIndex] = {
      ...dataLayer[lastEventIndex],
      ...popularFareData,
    };
  } else {
    dataLayer?.push(popularFareData);
  }

  window.dataLayer = dataLayer;
};

export const selectedPasssengerInfo = (data) => {
  const passengerCheckinData = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin:data?.select_passenger_checkin,
    flightId: data?.flightId,
    seat_number:data?.seatNumber,
    timestamp: new Date().toString(),
    login_status:data?.Login_status,
    user_id:getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type :data?.platform,
    user_type:data?.userType,
    market_language:data?.market,
    event: constant?.dapiDataLayer?.page_select_passenger_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:data?.checkIn_passenger_count,
    pnr_record_locator:data?.pnr_record_locator,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event === constant?.dapiDataLayer?.page_select_passenger_event
  );

  dataLayer?.push(passengerCheckinData);

  window.dataLayer = dataLayer; // Update the data layer
};

export const AddPassengers = (data) => {
  const AddPassengers = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: "NA",
    flightId: "NA",
    seat_number: "NA",
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    event: constant?.dapiDataLayer?.page_add_passenger_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:"NA",
    pnr_record_locator:data?.pnr_record_locator,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_add_passenger_event
  );

  dataLayer?.push(AddPassengers);

  window.dataLayer = dataLayer; // Update the data layer
};
export const DiscoverClick = (data) => {
   const DiscoverClick = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     selected_region: data?.selectedRegion,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     login_status: data?.Login_status,
     user_id: data?.userId,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     platform_type: data?.platform,
     market: data?.market,
     event: data?.eventName,
     device_name: getDeviceName()
   };
   const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.discoverClickEvent
   );
 
   dataLayer?.push(DiscoverClick);
 
   window.dataLayer = dataLayer;
 };
 export const BookNowClick = (data) => {
   const BookNowClick = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     selected_region: data?.selectedRegion,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     login_status: data?.Login_status,
     user_id: data?.userId,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     platform_type: data?.platform,
     market: data?.market,
     event: data?.eventName,
     device_name: getDeviceName()
   };
 
   const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.bookNowClickEvent
   );
 
   dataLayer?.push(BookNowClick);
 
   window.dataLayer = dataLayer;
 };
 export const LogInInitiation = (data) => {
   const LogInInitiation = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     market: data?.market,
     platform_type: data?.platform,
     user_id: data?.userId,
     login_status: data?.Login_status,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     user_type: data?.userType,
     tsession_id: data?.tsession_id,
     event: data?.eventName,
     device_name: getDeviceName()
   };
 
   const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.logInInitiationEvent
    );
 
   dataLayer?.push(LogInInitiation);
 
   window.dataLayer = dataLayer;
 };
 export const OTPGenerateSuccess = (data) => {
   const OTPGenerateSuccess = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     market: data?.market,
     platform_type: data?.platform,
     user_id: data?.userId,
     login_status: data?.Login_status,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     user_type: data?.userType,
     tsession_id: data?.tsession_id,
     event: data?.eventName,
     device_name: getDeviceName()
   };
 
   const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.otpGenerateSuccessEvent
   );
 
   dataLayer?.push(OTPGenerateSuccess);
 
   window.dataLayer = dataLayer;
 };
 export const LogInError = (data) => {
   const LogInError = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     market: data?.market,
     platform_type: data?.platform,
     user_id: data?.userId,
     login_status: data?.Login_status,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     user_type: data?.userType,
     tsession_id: data?.tsession_id,
     error_Id: data?.error_Id,
     error_text: data?.error_text,
     event: data?.eventName,
     device_name: getDeviceName()
   };
 
   const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.logInErrorEvent
   );
 
   dataLayer?.push(LogInError);
    window.dataLayer = dataLayer;
 };
 export const PasswordReset = (data) => {
   const PasswordReset = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     market: data?.market,
     platform_type: data?.platform,
     user_id: data?.userId,
     login_status: data?.Login_status,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     user_type: data?.userType,
     tsession_id: data?.tsession_id,
     event: data?.eventName,
     device_name: getDeviceName()
   };
      const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.passwordResetEvent
   );
 
   dataLayer?.push(PasswordReset);
 
   window.dataLayer = dataLayer;
 };
 export const LogInResendOTP = (data) => {
   const LogInResendOTP = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     market: data?.market,
     platform_type: data?.platform,
     user_id: data?.userId,
     login_status: data?.Login_status,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     user_type: data?.userType,
     tsession_id: data?.tsession_id,
     event: data?.eventName,
     device_name: getDeviceName()
   };
 
   const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.logInResendOTPEvent
   );
 
   dataLayer?.push(LogInResendOTP);
 
   window.dataLayer = dataLayer;
 };
 export const SignOutClick = (data) => {
   const SignOutClick = {
     primary_category: data?.primaryCategory,
     page_name: data?.pageName,
     page_id: data?.pageId,
     timestamp: new Date().toString(),
     market: data?.market,
     platform_type: data?.platform,
     user_id: data?.userId,
     login_status: data?.Login_status,
     site_language: data?.siteLanguage,
     site_country: data?.siteCountry,
     user_type: data?.userType,
     tsession_id: data?.tsession_id,
     event: data?.eventName,
     device_name: getDeviceName()
   };
 
   const lastEventIndex = dataLayer?.findIndex(
     (item) => item.event === constant?.dapiDataLayer?.signOutClickEvent
   );
 
   dataLayer?.push(SignOutClick);
 
   window.dataLayer = dataLayer;
};
export const modifySeatInfo = (data) => {
  const modifySeatCheckinData = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: "NA",
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language:  getMarkets("language"),
    site_country: getMarkets("country"),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    market_language: getMarkets("market"),
    event: constant?.dapiDataLayer?.page_modify_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:"NA",
    pnr_record_locator:data?.pnr_record_locator,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_modify_event_name
  );

  dataLayer?.push(modifySeatCheckinData);

  window.dataLayer = dataLayer; // Update the data layer
};

export const EditPasssengerInfo = (data) => {
  const editPassengerData = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: data?.select_passenger_checkin,
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    event: constant?.dapiDataLayer?.page_edit_passenger_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:data?.checkIn_passenger_count,
    pnr_record_locator:data?.pnr_record_locator,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_edit_passenger_event
  );

  dataLayer?.push(editPassengerData);

  window.dataLayer = dataLayer; // Update the data layer
};

export const SeatSelection = (data) => {
  const SelectedSeats = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: "NA",
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    event:
      constant?.dapiDataLayer?.page_extra_services_seat_selection_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:"NA",
    pnr_record_locator:data?.pnr_record_locator,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event ===
      constant?.dapiDataLayer?.page_extra_services_seat_selection_event
  );

  dataLayer?.push(SelectedSeats);

  window.dataLayer = dataLayer; // Update the data layer
};

export const ExtraServicesSubmission = (data) => {
  const ExtraServiceSuccess = {
    primaryCategory: data?.primaryCategory,
    pageId: data?.pageId,
    pageName: data?.pageName,
    event: constant?.dapiDataLayer?.page_extra_services_event,
    timestamp: new Date().toString(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_extra_services_event
  );

  dataLayer?.push(ExtraServiceSuccess);

  window.dataLayer = dataLayer; // Update the data layer
};

export const InitiateCheckinCancel = (data) => {
  const InitiateCheckinCancelPax = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: "NA",
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    event: constant?.dapiDataLayer?.page_cancel_checkin_event_name,
    pnr_record_locator: data?.pnr_record_locator,
    tsession_id:getSessionId(),
    checkIn_passenger_count:"NA",
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_cancel_checkin_event
  );

  dataLayer?.push(InitiateCheckinCancelPax);

  window.dataLayer = dataLayer; // Update the data layer
};

export const CheckinCancelledPassengers = (data) => {
  const CheckinCancelledPassengers = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: data?.select_passenger_checkin,
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    event:
      constant?.dapiDataLayer?.page_extra_services_cancel_checkin_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:data?.checkIn_passenger_count,
    pnr_record_locator: data?.pnr_record_locator,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event ===
      constant?.dapiDataLayer?.page_extra_services_cancel_checkin_event
  );

  dataLayer?.push(CheckinCancelledPassengers);

  window.dataLayer = dataLayer; // Update the data layer
};

export const CompleteCheckedinPassengers = (data) => {
  const completeCheckedinPassengers = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: "NA",
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    pnr_record_locator: data?.pnr_record_locator,
    event: constant?.dapiDataLayer?.page_complete_checkin_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:data?.checkincount,
    ffp_update_count:data?.ffp_updated_count,
    group_booking:data?.group_booking,
    ancillary_services:constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    device_name: getDeviceName(),
    trip_type: getTripType(),
    fromDate: data?.from_date,
    toDate: data?.to_date,
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event === constant?.dapiDataLayer?.page_complete_checkin_event
  );

  dataLayer?.push(completeCheckedinPassengers);

  window.dataLayer = dataLayer; // Update the data layer
};

export const ExitCheckinData = (data) => {
  const exitCheckin = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: data?.select_passenger_checkin,
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    event: constant?.dapiDataLayer?.page_exit_checkin_event_name,
    tsession_id:getSessionId(),
    checkIn_passenger_count:"NA",
    pnr_record_locator:data?.pnr_record_locator,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_exit_checkin_event
  );

  dataLayer?.push(exitCheckin);

  window.dataLayer = dataLayer; // Update the data layer
};

export const BoardingPassData = (data) => {
  const boardingPass = {
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: data?.select_passenger_checkin,
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    timestamp: new Date().toString(),
    login_status: data?.Login_status,
    user_id: getUserId(),
    site_language: data?.siteLanguage,
    site_country: data?.siteCountry,
    platform_type: data?.platform,
    user_type: data?.userType,
    market_language: data?.market,
    event: constant?.dapiDataLayer?.page_boarding_pass_checkin_event_name,
    tsession_id: data?.tsession_id,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    eboarding_pass_status: data?.eboarding_pass_status,
    pnr_record_locator: data?.pnr_record_locator,
    ancillary_services:constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) =>
      item.event === constant?.dapiDataLayer?.page_boarding_pass_checkin_event
  );

  dataLayer?.push(boardingPass);

  window.dataLayer = dataLayer; // Update the data layer
};

export const ErrorData = (data) => {
  const errorScenario = {
    error_Id: data?.error_Id,
    error_text: data?.error_text,
    pnr_record_locator: data?.pnr_record_locator,
    primary_category: data?.primaryCategory,
    page_name: data?.pageName,
    event: constant?.dapiDataLayer?.page_error_event_name,
    timestamp: new Date().toString(),
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id: getSessionId(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_error_checkin_event
  );

  dataLayer?.push(errorScenario);

  window.dataLayer = dataLayer; // Update the data layer
};

export const shareBoardingPass = (data) => {
  const shareBoardingPass = {
    eboarding_pass_status: data?.eboarding_pass_status,
    button_text: data?.button_text,
    page_name: data?.pageName,
    primary_category: data?.primaryCategory,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: data?.select_passenger_checkin,
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    pnr_record_locator: data?.pnr_record_locator,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    event: constant?.dapiDataLayer?.page_boarding_pass_event_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id: getSessionId(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_boarding_pass_event
  );

  dataLayer?.push(shareBoardingPass);

  window.dataLayer = dataLayer; // Update the data layer
};

export const addBoardingPass = (data) => {
  const addBoardingPass = {
    eboarding_pass_status: data?.eboarding_pass_status,
    button_text: data?.button_text,
    page_name: data?.pageName,
    primary_category: data?.primaryCategory,
    origin: data?.origin,
    destination: data?.destination,
    select_passenger_checkin: data?.select_passenger_checkin,
    flightId: data?.flightId,
    seat_number: data?.seatNumber,
    pnr_record_locator: data?.pnr_record_locator,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    event: constant?.dapiDataLayer?.page_add_boarding_pass_event_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id: getSessionId(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_add_boarding_pass_event
  );

  dataLayer?.push(addBoardingPass);

  window.dataLayer = dataLayer; // Update the data layer
};

export const joinNowData = (data) => {
  const joinNow = {
    button_text: data?.button_text,
    page_name: getLocationName(),
    primary_category: data?.primaryCategory,
    event: constant?.dapiDataLayer?.page_join_now_event_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id: getSessionId(),
    device_name: getDeviceName()
  };

  const lastEventIndex = dataLayer?.findIndex(
    (item) => item.event === constant?.dapiDataLayer?.page_join_now_event
  );

  dataLayer?.push(joinNow);

  window.dataLayer = dataLayer; // Update the data layer
};

export const ffPUpdateData = (data) => {
  const ffpUpdate = {
    button_text: data?.button_text,
    pnr_record_locator:data?.pnr_record_locator,
    page_name: constant?.dapiDataLayer?.page_passenger_details,
    primary_category: data?.primaryCategory,
    event: constant?.dapiDataLayer?.page_ffp_update_event_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id: getSessionId(),
    device_name: getDeviceName()
  };

  dataLayer?.push(ffpUpdate);

  window.dataLayer = dataLayer; // Update the data layer
};

export const ffPSubmitData = (data) => {
  const ffpSubmit = {
    page_name: constant?.dapiDataLayer?.page_passenger_details,
    primary_category: data?.primaryCategory,
    event: constant?.dapiDataLayer?.page_ffp_submit_event_name,
    pnr_record_locator:data?.pnr_record_locator,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id: getSessionId(),
    device_name: getDeviceName()
  };

  dataLayer?.push(ffpSubmit);

  window.dataLayer = dataLayer; // Update the data layer
};

export const viewInsuranceData = (data) => {
  const viewInsurance = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    device_name: getDeviceName(),
    event: constant?.dapiDataLayer?.page_view_insurance_event_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    page_name: getLocationName(),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName(),
    trip_type: getTripType()
  };
  dataLayer?.push(viewInsurance);

  window.dataLayer = dataLayer; // Update the data layer
};

export const clickInsuranceData = (data) => {
  const clickInsurance = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    device_name: getDeviceName(),
    event_label: data?.eventLabel,
    event: constant?.dapiDataLayer?.page_link_select_insurance_event,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    page_name: constant?.dapiDataLayer?.page_insurance_name,
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  };

  dataLayer?.push(clickInsurance);

  window.dataLayer = dataLayer;
};

export const selectPrivacyData = (data) => {
  const privacyPolicy = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    device_name: getDeviceName(),
    event_label: data?.eventLabel,
    event: constant?.dapiDataLayer?.page_privacy_policy_event_name,
    page_name: constant?.dapiDataLayer?.page_insurance_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  };

  dataLayer?.push(privacyPolicy);

  window.dataLayer = dataLayer;
};

export const confirmAddInsuranceData = (data) => {
  const confirmAddInsurance = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    device_name: getDeviceName(),
    ancillary_price: `${constant?.dapiDataLayer?.ancillary_insurance_name}${data?.ancillaryPrice}${" "}${data?.currencyType}` ?? "NA",
    purchase_price:data?.ancillaryPrice ?? "NA",
    currency_type: data?.currencyType ?? "NA",
    event: constant?.dapiDataLayer?.page_confirm_add_insurance_event_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    page_name: constant?.dapiDataLayer?.page_insurance_name,
    ancillary_services:constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    device_name: getDeviceName(),
    trip_type: getTripType()
  };
  dataLayer?.push(confirmAddInsurance);

  window.dataLayer = dataLayer; // Update the data layer
};

export const discardInsuranceData = (data) => {
  const discardInsurance = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    device_name: getDeviceName(),
    event: constant?.dapiDataLayer?.page_discard_insurance_event_name,
    eventLabel:data?.eventLabel,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    page_name: constant?.dapiDataLayer?.page_insurance_name,
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  };
  dataLayer?.push(discardInsurance);

  window.dataLayer = dataLayer; // Update the data layer
};

export const ErrorInsuranceData = (data) => {
 const clickInsurance = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    event: constant?.dapiDataLayer?.page_payment_failure_event,
    error_text: data?.error_text,
    page_name: constant?.dapiDataLayer?.page_insurance_name,
    error_id:"NA",
    device_name: getDeviceName(),
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()

  };

  dataLayer?.push(clickInsurance);

  window.dataLayer = dataLayer; // Update the data layer
};

export const ErrorPageClickData = (data) => {
 const clickInsurance = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    button_text: data?.buttonText,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    error_text: data?.error_text,
    event: constant?.dapiDataLayer?.page_error_payment_event_name,
    error_id:data?.error_id,
    device_name: getDeviceName(),
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    page_name: getLocationName(),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  };

  dataLayer?.push(clickInsurance);

  window.dataLayer = dataLayer;
}

export const initiatePaymentData = (data) => {
  const initiatePaymentInsurance = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    event_label: data?.eventLabel,
    device_name: getDeviceName(),
    ancillary_price: `${constant?.dapiDataLayer?.ancillary_insurance_name}${data?.ancillaryPrice}${" "}${data?.currency_type}` ?? "NA",
    currency_type:data?.currency_type,
    purchase_price:data?.purchase_price,
    event: constant?.dapiDataLayer?.page_initiate_payment_event,
    page_name: constant?.dapiDataLayer?.page_insurance_name,
    ancillary_services: constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  };
  dataLayer?.push(initiatePaymentInsurance);

  window.dataLayer = dataLayer; // Update the data layer
};

export const processPaymentData = (data) => {
  const processPayment = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    page_name: constant?.dapiDataLayer?.page_payment_process_name,
    event: constant?.dapiDataLayer?.page_payment_process_event,
    event_label: constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    device_name: getDeviceName(),
    // payment_method_select: data?.payment_method_select,
    ancillary_price: `${constant?.dapiDataLayer?.ancillary_insurance_name}${data?.ancillary_price}${" "}${data?.currency_type}` ?? "NA",
    purchase_price:data?.purchase_price,
    currency_type:data?.currency_type,
    ancillary_services: constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName()
  };

  dataLayer?.push(processPayment);

  window.dataLayer = dataLayer; // Update the data layer
};

export const purchaseCompleteData = (data) => {
   const purchaseComplete = {
    primary_category: data?.primaryCategory,
    pnr_record_locator: data?.pnr_record_locator,
    flightId: data?.flightId,
    checkIn_passenger_count: data?.checkIn_passenger_count,
    origin: data?.origin,
    destination: data?.destination,
    fromDate: data?.from_date,
    toDate: data?.to_date,
    // payment_method_select: data?.payment_method_select,
    transaction_id:data?.transaction_id,
    currency_type:data?.currency_type,
    purchase_price:data?.purchase_price,
    ancillary_price: `${constant?.dapiDataLayer?.ancillary_insurance_name}${data?.ancillary_price}${" "}${data?.currency_type}` ?? "NA",
    ancillary_services: constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    event: constant?.dapiDataLayer?.page_purchase_confirmation_event,
    event_label:constant?.dapiDataLayer?.page_insurance_purchase_confiramtion,
    ffp_update_count: "NA",
    device_name: getDeviceName(),
    page_name: data?.page_name,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName(),
    trip_type: getTripType()
  };

  dataLayer?.push(purchaseComplete);

  window.dataLayer = dataLayer; // Update the data layer

}

export const purchaseInsuranceData = (data) => {
  const purchaseInsurance = {
    event: constant?.dapiDataLayer?.insurance_purchase,
    ecommerce: {
      transaction_id: data?.transaction_id,
      value: parseInt(data?.ancillary_price),
      currency: data?.currency_type,
      items: [
        {
          item_id: `${constant?.dapiDataLayer?.insurance_cateogry}|${data?.origin}_${data?.destination}|${data?.flightId}|${constant?.dapiDataLayer?.ancillary_provider_name}`,
          item_name: `${data?.origin}_${data?.destination}- ${
            getTripType() === "One Way"
              ? constant?.dapiDataLayer?.insurance_purchase_one_way
              : constant?.dapiDataLayer?.insurance_purchase_round_trip
          }`,
          item_brand: constant?.dapiDataLayer?.insurance_item_brand,
          item_variant: "NA",
          item_category: constant?.dapiDataLayer?.insurance_cateogry,
          item_category2: "NA",
          item_category3: constant?.dapiDataLayer?.insurance_purchase_flow,
          item_category4: constant?.dapiDataLayer?.insurance_chargeable,
          item_category5: constant?.dapiDataLayer?.ancillary_provider_name,
          price: parseInt(data?.ancillary_price),
          quantity: parseInt("1"),
          item_trip_departure_date: data?.from_date,
          item_flight_number: data?.flightId,
        },
      ],
    },
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    device_name: getDeviceName(),
    trip_type: getTripType(),
    travel_group: data?.travel_group,
    search_ond: `${data?.origin}_${data?.destination}- ${
      getTripType() === "One Way"
        ? constant?.dapiDataLayer?.insurance_purchase_one_way
        : constant?.dapiDataLayer?.insurance_purchase_round_trip
    }`,
    jsession_id: getSessionId() ?? "NA",
    pnr_record_locator: data?.pnr_record_locator,
    content_group: constant?.dapiDataLayer?.insurance_content_grp,
    ff_program: "NA",
    market_language: getMarkets("market"),
    page_location: data?.page_name,
    timestamp: new Date().toString(),
  };

  dataLayer?.push(purchaseInsurance);

  window.dataLayer = dataLayer;
};

export const honeyPot = (data) =>{
  const honeyPotData = {
    orgin: data?.origin ?? "",
    destination: data?.destination ?? "",
    search_ond: data?.searchOnd ?? "",
    promocode: data?.promocode || "NA",
    travel_class: data.travelClass,
    travel_group: data?.travelGroup,
    primary_category: data?.category,
    pageName: data?.pageName,
    event:"honeypot_filled",
    // route_type: constant?.osciDataLayer?.flightStatusEvent_eventName,
    fromDate: data?.fromDate,
    toDate: data?.toDate,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    device_name: getDeviceName(),
    timestamp: new Date().toString(),
  };

  dataLayer?.push(honeyPotData);

  window.dataLayer = dataLayer;
}

export const travelReadyInfo = (data) => {
  const travelReadyData = {
    primary_category: data?.primaryCategory,
    event_label:data?.event_label,
    page_name: data?.pageName,
    origin: data?.origin,
    destination: data?.destination,
    pnr_record_locator:data?.pnr_record_locator,
    event: data?.event,
    login_status: getUserType("status"),
    user_id: getUserId(),
    site_language: getMarkets("language"),
    site_country: getMarkets("country"),
    market_language: getMarkets("market"),
    timestamp: new Date().toString(),
    platform_type: getDeviceType(),
    user_type: getUserType("type"),
    tsession_id:getSessionId() ?? "NA",
    device_name: getDeviceName(),
    trip_type: getTripType(),
    search_ond: `${data?.origin}_${data?.destination}-${
        getTripType() === "One Way"
          ? constant?.dapiDataLayer?.insurance_purchase_one_way
          : constant?.dapiDataLayer?.insurance_purchase_round_trip
      }`,
  };

  dataLayer?.push(travelReadyData);

  window.dataLayer = dataLayer; // Update the data layer
};